import type { FC, PropsWithChildren } from 'react';

import { useAuth } from 'hooks/useAuth';

import NotPermissionAtAllView from 'views/errors/NotPermissionAtAllView';
import NoPermissionView from 'views/errors/NotPermissionView';

import type { Permission } from 'types/permissions';

type AuthGuardProps = PropsWithChildren<{
  permission?: Permission;
  companyPermission?: Permission;
}>;

export const PermissionGuard: FC<AuthGuardProps> = ({ children, permission, companyPermission }) => {
  const { permissions, companyPermissions } = useAuth();

  if (permissions.size === 0) {
    return <NotPermissionAtAllView />;
  }

  if (
    (permission && !permissions.has(permission)) ||
    (companyPermission && !companyPermissions.has(companyPermission))
  ) {
    return <NoPermissionView />;
  }

  return <>{children}</>;
};
